import { css } from '@mui/material';
import { theme } from './theme';

const subtleNoiseDataUri =
  'data:image/svg+xml,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="256" height="256"><filter id="n" x="0" y="0"><feTurbulence type="fractalNoise" baseFrequency="0.02" numOctaves="3" result="t"/><feColorMatrix in="t" type="saturate" values="0"/><feComponentTransfer in="t"><feFuncA type="linear" slope="0.1"/></feComponentTransfer></filter><rect width="100%" height="100%" filter="url(#n)"/></svg>`,
  ).replace(/#/g, '%23');

export const globalStyles = css`
  body,
  html,
  #root {
    height: 100%;
    margin: 0;
    padding: 0;
    background-color: ${theme.palette.background.default};

    background-image: url('${subtleNoiseDataUri}');
    background-repeat: repeat;
    font-family: ${theme.typography.fontFamily};
    font-size: ${theme.typography.body1.fontSize};
  }

  a {
    text-decoration: underline;
  }
  a:hover {
    text-decoration: underline;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: ${theme.typography.h1.fontFamily};
  }
`;
